import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import PopupMask from "@/componentsUI/PopupMask";
import InvitePopup from "./InvitePopup";

/**
 * NiceModal 包装层，使 InvitePopup 可以通过编排器独立调度。
 * InvitePopup 自带全屏遮罩，无需额外 PopupMask。
 */
const InvitePopupModal = NiceModal.create(() => {
  const { visible, resolve, remove } = useModal();

  const handleClose = () => {
    resolve();
    remove();
  };

  return (
    <PopupMask visible={visible}>
      <InvitePopup onClose={handleClose} />
    </PopupMask>
  );
});

export default InvitePopupModal;
